import { FormControl, InputLabel, MenuItem, Select, Autocomplete, TextField } from "@mui/material";
import get from "lodash.get";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

function SelectComponent3(props) {
    const {
        menuItem = [],
        label,
        setSelections,
        required = false,
        procedureName = null,
        multiple = false,
        mode,
        minWidth = "120px",
        value: valueProp,
    } = props;

    const getInitialSelection = () => {
        if (valueProp !== undefined && valueProp !== null && valueProp !== "") return valueProp;
        if (mode === "entity") return { displayName: "Initimation Number", id: "INTIMATION_NUMBER" };
        if (mode === "date") return { id: "DATE_UPDATED", name: "Updated Date" };
        return "";
    };

    const [selection, setSelection] = useState(getInitialSelection);

    // Sync internal state when the controlled value prop changes from outside
    useEffect(() => {
        if (valueProp !== undefined && valueProp !== null && valueProp !== "") {
            setSelection(valueProp);
        }
    }, [valueProp]);

    const handleChange = (event) => {
        setSelection(event.target.value);
    };
    const handleAutocompleteChange = (event, value) => {
        setSelection(value);
    };

    useEffect(() => {
        setSelections(selection);
    }, [selection]);

    return (
        <div>
            <FormControl
                variant="standard"
                fullWidth
                sx={{ m: 1, minWidth: minWidth }}
            >
                <InputLabel id="demo-simple-select-standard-label" required={required}>
                    {label}
                </InputLabel>
                {!multiple &&

                    //     <Select
                    //   labelId="demo-select-small-label"
                    //   id="demo-select-small"
                    //   label=""
                    //   value={typeof selection === "object" ? selection.id : selection}
                    //   onChange={handleChange}
                    //   displayEmpty
                    // >
                    //   {procedureName && (
                    //     <MenuItem disabled value="">
                    //       <p style={{ margin: 0, textAlign: "left" }}>{procedureName}</p>
                    //     </MenuItem>
                    //   )}
                    //
                    //   {menuItem.length > 0 &&Abnormal uterine and vaginal bleeding
                    //     menuItem.map((item, index) => (
                    //       <MenuItem
                    //         value={
                    //           item.productCode ||
                    //           item.hospitalRoomName ||
                    //           item.illnessName ||
                    //           item.fileName ||
                    //           (item.id === 0 ? "0" : item.id) ||
                    //           item
                    //         }
                    //         key={index}
                    //         style={{ padding: 8 }}
                    //       >
                    //         {" "}
                    //         {item.productCode ||
                    //           item.name ||
                    //           item.displayName ||
                    //           item.hospitalRoomName ||
                    //           item.illnessName ||
                    //           item.fileName ||
                    //           item}
                    //       </MenuItem>
                    //     ))}
                    // </Select>

                    <Autocomplete
                        id="demo-autocomplete"
                        options={menuItem}
                        getOptionLabel={(option) =>
                            option?.productCode ||
                            option?.name ||
                            option?.displayName ||
                            option?.hospitalRoomName ||
                            option?.illnessName ||
                            option?.fileName ||
                            option?.toString?.() || ""
                        }
                        value={
                            typeof selection === "object"
                                ? selection
                                : menuItem.find((item) =>
                                item.productCode === selection ||
                                item.hospitalRoomName === selection ||
                                item.illnessName === selection ||
                                item.fileName === selection ||
                                item.id === selection
                            ) || null
                        }

                        onChange={(event, newValue) => {
                            handleChange({
                                target: {
                                    value: newValue
                                        ?
                                        newValue.productCode ??
                                        newValue.hospitalRoomName ??
                                        newValue.illnessName ??
                                        newValue.fileName ??
                                        newValue.id ??
                                        newValue
                                        : "",
                                },
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={procedureName || ""}
                                variant="standard"

                                InputLabelProps={{
                                    style: { color: '#000' } // black or any dark color
                                }}
                            />
                        )}
                        isOptionEqualToValue={(option, value) =>
                            option === value ||
                            option?.id === value?.id
                        }
                    />


                }
                {multiple && <Autocomplete
                    multiple
                    id="tags-standard"
                    sx={{mt: '1rem'}}
                    options={menuItem}
                    getOptionLabel={(option) => (`${get(option, ['illnessName'])} - ${get(option, ['defaultICDCode'])}`)}
                    onChange={handleAutocompleteChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                        />
                    )}
                />}
            </FormControl>
        </div>
    );
}

export default SelectComponent3;
